module.exports = __webpack_public_path__ + "static/media/member nalas-03.c8e6ba2c.png";